module.exports = __webpack_public_path__ + "static/media/icon-hcp-steps-organization.024593d1.svg";